import React, { useCallback, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Alert, Image, notification, Upload } from "antd";

import { config } from "../../config";
import { getUserDetail } from "../../utils/helper";
import { deleteCompanyInfoImage } from "../../store/api/companyInfo";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const kindToFilePath = {
  introduction: "introductionFilePath",
  capitalStructure: "capitalStructureFilePath",
  organizationStructure: "organizationStructureFilePath",
};

export const ImageUpload = ({ infoKey, companyInfo }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const filePathKey = kindToFilePath[infoKey];

  const [fileList, setFileList] = useState(
    companyInfo?.[filePathKey]
      ? [
          {
            uid: companyInfo.id,
            name: `image-${companyInfo.id}`,
            status: "done",
            url: `${config.filesBaseUrl}/${companyInfo[filePathKey]}`,
          },
        ]
      : []
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleRemove = (item) => {
    deleteCompanyInfoImage(companyInfo.id, filePathKey)
      .then(({ data }) => {
        notification.success({ message: "Successfully removed image" });
      })
      .catch((error) => {
        notification.error({ message: "Could not remove image" });
      });
  };

  const handleChange = useCallback(
    ({ fileList: newFileList, file }) => {
      if (file.status !== "done") {
        setFileList(newFileList);
      } else {
        const index = newFileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          const { id } = file.response;
          const filePath = file.response[filePathKey];

          newFileList = [
            {
              uid: id,
              name: `image-${id}`,
              status: "done",
              url: `${config.filesBaseUrl}/${filePath}`,
            },
          ];

          setFileList(newFileList);
        }
      }
    },
    [setFileList]
  );

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <UploadOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {fileList.length ? "Update" : "Upload"}
      </div>
    </button>
  );
  return (
    <>
      <Alert
        message="Recommended size: max 2MB"
        type="warning"
        style={{ marginTop: "4px", marginBottom: "16px" }}
      ></Alert>
      <Upload
        action={`${config.apiBaseUrl}/companyInfo/upload`}
        data={{ kind: infoKey }}
        accept=".jpeg,.jpg,.png"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        headers={{ Authorization: `Bearer ${getUserDetail()?.accessToken}` }}
        onChange={handleChange}
        onRemove={handleRemove}
      >
        {uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
